import { render, staticRenderFns } from "./dowenloadApp.vue?vue&type=template&id=29480d26&"
import script from "./dowenloadApp.vue?vue&type=script&lang=js&"
export * from "./dowenloadApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports